import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// build/index.html already contains the prerendered page (scripts/prerender.js).
// Hydrating reuses that HTML instead of throwing it away and painting it again,
// which is what kept the Largest Contentful Paint waiting for the whole bundle.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
